import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosApiInstance from "../../axios/axiosinstance";
import { EntUser } from "../../models/user";
import { RootState } from "../root/root-state.interface";
import { EntRole } from "../../models/role";
import { getCookie } from "typescript-cookie";
import { EntRoleAvailableRoutes } from "../../models/rolesAvailableRoutes";

export const AUTH_SLICE_KEY = "authSlice";

interface Messages {
  messageKy: string;
  messageRu: string;
}

export interface AuthState {
  isLoggedIn: boolean;
  changePassword: boolean;
  hasValidToken: boolean;
  pin: string;
  id: number;
  patronymic: string;
  secondName: string;
  passwordChangeNextLogon: boolean;
  name: string;
  errorMessage: string;
  roles: EntRole[]|null;
  availableRoutes: EntRoleAvailableRoutes|null;
  governmentAlias: string|null;
}

const initialState = {
  hasValidToken: false,
  isLoggedIn: localStorage.getItem('isLoggedIn') === 'true',
  changePassword: localStorage.getItem('changePassword') === 'true',

  errorMessage: ""
} as AuthState;

interface IAuthResponse {
  success: boolean;
  msg: Messages;
  error: string;
  res: string;
  // res: ITokens | IBlockedInfo;
  t: Date;
  v: string;
}

interface IBlockedInfo {
  blockedTime: Date;
  blockedReason: string;
}

interface ITokens {
  accessToken: string;
  refreshToken: string;
}

interface IAuthParams {
  username: string;
  password: string;
}

interface ILanguageParams {
  userId: number;
  langId: number;
}

export class AuthSliceMethods {

  static errorMessage: string = "";

  static login = createAsyncThunk(
	"auth/login",
	async (params: IAuthParams): Promise<IAuthResponse> => {
	  try {

		var res = await axiosApiInstance.post<IAuthResponse>(
		  `admin-panel/login`,
		  { username: params.username, password: params.password },

		  {
			headers: {
			  "Content-Type": "application/json;charset=utf-8"
			},
		  }
		);

		// if(res.data?.res === null){
		//   this.getUserInfoStatus = false;
		// }else{
		//   this.getUserInfoStatus = true;
		// }

		return res.data;
	  } catch (ex: any) {
		const isKyrgyz = getCookie('i18next') === 'ky';
		const lang = isKyrgyz ? 'kg' : 'ru';
		const res = ex.response?.data?.res;

		let errorMessage = "Неизвестная ошибка";

		if (Array.isArray(res)) {
		  errorMessage = res.map((error: any) => error[lang] || error.ru).join(', \n');
		} else if (res && typeof res === 'object' && (res[lang] || res.ru)) {
		  errorMessage = res[lang] || res.ru;
		} else if (typeof res === 'string') {
		  errorMessage = res;
		}

		this.errorMessage = errorMessage;

		return Promise.reject(ex);
	  }
	}
  );

  static block = createAsyncThunk(
	"auth/block",
	async (user: EntUser) => {
	  if (!user) return;
	  try {
		await axiosApiInstance.post(`/admin-panel/ban/${ user.id }`);
	  } catch (ex: any) {
		this.errorMessage = `${ ex.response.data.msg.kg }/${ ex.response.data.msg.ru }`;
	  }
	}
  );

  static unblock = createAsyncThunk(
	"auth/unblock",
	async (user: EntUser) => {
	  if (!user) return
	  try {
		await axiosApiInstance.post(`/admin-panel/unban/${ user.id }`)
	  } catch (ex: any) {
		this.errorMessage = `${ ex.response.data.msg.kg }/${ ex.response.data.msg.ru }`;
	  }
	})

  static logout = createAsyncThunk("auth/logout", async () => {
	try {
	  //this.getUserInfoStatus = false;
	  //var res = await axiosApiInstance.post("ap/logout");
	} catch (ex: any) {
	}
  });


  static getUserInfo = createAsyncThunk(
	"auth/getUserInfo",
	async (): Promise<EntUser> => {
	  try {
		var res = await axiosApiInstance.get(`user/by-jwt`);

		//i18next.changeLanguage(res.data.result.langId.alias);
		return res.data.res;
	  } catch (ex: any) {
		throw ex;
	  }
	}
  );

  static setLanguage = createAsyncThunk(
	"auth/setLanguage",
	async (params: ILanguageParams): Promise<EntUser> => {
	  try {
		// if(this.getUserInfoStatus){

		// }
		var res = await axiosApiInstance.post(`ap/user-set-lang?userId=${ params.userId }&langId=${ params.langId }`);
		return res.data.result;
		return new EntUser();
	  } catch (ex: any) {
		throw ex;
	  }
	}
  )
}


export const authSlice = createSlice({
  name: AUTH_SLICE_KEY,
  initialState,
  reducers: {
	clearAuthCredentials: (state) => {
	  localStorage.removeItem("isLoggedIn");
	  localStorage.removeItem("token");
	  localStorage.removeItem("refreshToken");
	  localStorage.removeItem("tokenRefreshing");
	  localStorage.removeItem("availableRoutes");
	  state.pin = '';
	  state.patronymic = '';
	  state.name = '';
	  state.id = 0;
	  state.secondName = '';
	  state.isLoggedIn = false;
	  state.hasValidToken = false;
	  state.passwordChangeNextLogon = false;
	  state.roles = null;
	},
  },
  extraReducers: (builder) => {
	builder
	  .addCase(AuthSliceMethods.login.fulfilled, (state, action) => {
		if (action.payload?.res === null) {
		  state.errorMessage = 'Проверьте правильность введенного пароля';
		} else {
		  localStorage.setItem("isLoggedIn", "true");
		  localStorage.setItem("token", action.payload.res);
		  // localStorage.setItem("refreshToken", (action.payload.res as ITokens).refreshToken);
		  state.isLoggedIn = true;
		  state.hasValidToken = true;
		  state.pin = '';
		  state.patronymic = '';
		  state.passwordChangeNextLogon = false;
		  state.name = '';
		  state.id = 0;
		  state.secondName = '';
		  state.roles = null;
		}
	  })
	  .addCase(AuthSliceMethods.logout.fulfilled, (state) => {
		localStorage.removeItem("isLoggedIn");
		localStorage.removeItem("changePassword");
		localStorage.removeItem("token");
		localStorage.removeItem("refreshToken");
		localStorage.removeItem("tokenRefreshing");
		localStorage.removeItem("availableRoutes");
		state.pin = '';
		state.patronymic = '';
		state.passwordChangeNextLogon = false;
		state.name = '';
		state.id = 0;
		state.secondName = '';
		state.isLoggedIn = false;
		state.hasValidToken = false;
		state.roles = null;
	  })
	  .addCase(AuthSliceMethods.getUserInfo.fulfilled, (state, action) => {
		if (action.payload) {
		  // localStorage.setItem("changePassword", action.payload.changePasswordNextLogon ? "true" : "false");
		  state.isLoggedIn = true;
		  state.pin = action.payload.pin;
		  state.patronymic = action.payload.patronymic;
		  state.name = action.payload.name;
		  state.id = action.payload.id;
		  state.secondName = action.payload.secondName;
		  state.roles = action.payload.roles;
		  state.passwordChangeNextLogon = action.payload.passwordChangeNextLogon || false;
		  state.hasValidToken = true;
		  state.governmentAlias = action.payload.position?.department?.government?.alias || null;

		  localStorage.setItem("availableRoutes", JSON.stringify(action.payload.availableRoutes));
		} else {
		  localStorage.setItem("changePassword", "false");
		  state.pin = '';
		  state.patronymic = '';
		  state.name = '';
		  state.id = 0;
		  state.secondName = '';
		  state.isLoggedIn = false;
		  state.changePassword = false;
		  state.hasValidToken = false;
		  state.passwordChangeNextLogon = false;
		}
	  })
	  .addCase(AuthSliceMethods.getUserInfo.rejected, (state, action) => {
		authSlice.actions.clearAuthCredentials();
	  })
	  .addCase(AuthSliceMethods.login.rejected, (state, action) => {
		authSlice.actions.clearAuthCredentials();
		state.errorMessage = AuthSliceMethods.errorMessage;
	  })
	// .addCase(AuthSliceMethods.setLanguage.fulfilled, (state, action) => {
	//   state.isLoggedIn = true;
	//   state.pin = action.payload.pin;
	//   state.patronymic = action.payload.patronymic;
	//   state.roles = action.payload.roles;
	//   state.name = action.payload.name;
	//   state.id = action.payload.id;
	//   state.secondName = action.payload.secondName;
	//   state.changePassword = false;
	//   state.hasValidToken = true;
	// })
	// .addCase(AuthSliceMethods.setLanguage.rejected, (state, action) => {
	//   authSlice.actions.clearAuthCredentials();
	//   state.errorMessage = AuthSliceMethods.errorMessage;
	// })
  },
});

export const getAuthState = (rootState: RootState): AuthState =>
  rootState[AUTH_SLICE_KEY];

